import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { requery } from "../../../actions/updateHelp";
import { withRouter } from "react-router-dom";
import { toast } from "react-hot-toast";
import $ from "jquery";
import axios from "axios";
import * as myConstList from "../../../BaseUrl";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Modal, Button } from "react-bootstrap";

const config = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
const baseUrl = myConstList.baseUrl;
class UpcomingContest extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      records: [],
      bonus: 0,
      id: this.props.id,
      description: "",
      isEntryFeesModaL: false,
      message: "",
      username: user.name,
      showResults: false,
      showTeaxtArea: true,
      entryFee: 0,
      checked: false,
      bonusper: 0,
      bonus: 0,
      totalde: 0,
      errors: {},
      days: [],
      hours: [],
      minutes: [],
      seconds: [],
      show: false,
      cashWalletChecked: false,
      winningWalletChecked: false,
      rewardWalletChecked: false,
      cashWalletDeduct: 0,
      winningWalletDeduct: 0,
      rewardWalletDeduct: 0,
      participateBtnDisable: false,
      couponRequired: "",
      winningCash: 0,
      urltemp: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.serverTime) {
      this.setState({
        serverTime: nextProps.serverTime,
      });
    }
    if (nextProps.record) {
      //if(nextProps.record.length !== this.state.records.length ){
      let winningCash = 0;
      let cashWalletBalance = 0;
      if (nextProps.winningCash != null) {
        winningCash = nextProps.winningCash;
      }
      if (nextProps.cashWalletBalance != null) {
        cashWalletBalance = nextProps.cashWalletBalance;
      }

      this.setState({
        records: nextProps.record,
        bonus: nextProps.bonus,
        cashWalletBalance: cashWalletBalance,
        winningWalletBalance: nextProps.winningWalletBalance,
        userAvaliablePoints: nextProps.totalPoints,
        contestCreated: nextProps.contestCreated,
        winningCash: winningCash,
      });
      //}
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.auth !== undefined &&
      nextProps.auth.user !== undefined &&
      nextProps.auth.user.data !== undefined &&
      nextProps.auth.user.data.message !== undefined &&
      nextProps.auth.user.data.success
    ) {
      this.setState({
        message: nextProps.auth.user.data.message,
      });
    }
  }
  componentDidMount() {
    document.body.classList.add("traading-contest-page");
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
  }

  getNodesToRemoveFromElement = (stringContent) => {
    var div = document.createElement("div");
    div.innerHTML = stringContent;
    var text = div.textContent || div.innerText || "";
    return text;
  };
  participatedata = (data) => {
    this.setState({
      id: data.id,
      entryFee: data.entryFee,
      virtualFund: data.virtualFund,
      isEntryFees: data.isEntryFees,
      max_particepate: data.max_particepate,
      show: true,
      couponRequired: data.couponRequired,
      poitsRequire: data.entryFeePoints,
    });
    var endDate = new Date(data.endDate);
    endDate = endDate.toString();
    var startDate = new Date(data.startDate);
    startDate = startDate.toString();
    window.webengage.track("Participation Started", {
      "Category Name": "Upcoming",
      "Contest Name": data.contestName,
      "Prize pool": data.winningAmount,
      "Started At": new Date(startDate),
      "Ends in": new Date(endDate),
      "Number of participants": Number(data.numOfParticipation),
    });
  };
  participatedata22 = (data) => {
    this.setState({
      id: data.id,
      entryFee: data.entryFee,
      virtualFund: data.virtualFund,
      max_particepate: data.max_particepate,
      show: false,
      couponRequired: data.couponRequired,
      poitsRequire: data.entryFeePoints,
      entryFeeTypeRequired: data.entryFeeTypeRequired,
    });
    var endDate = new Date(data.endDate);
    endDate = endDate.toString();
    var startDate = new Date(data.startDate);
    startDate = startDate.toString();
    window.webengage.track("Participation Started", {
      "Category Name": "Upcoming",
      "Contest Name": data.contestName,
      "Prize pool": data.winningAmount,
      "Started At": new Date(startDate),
      "Ends in": new Date(endDate),
      "Number of participants": Number(data.numOfParticipation),
    });

    window.webengage.track("Participation Completed", {
      "Category Name": "Upcoming",
      "Contest Name": data.contestName,
      "Prize pool": data.winningAmount,
      "Started At": new Date(startDate),
      "Ends in": new Date(endDate),
      "Number of participants": Number(data.numOfParticipation),
      "Coupon code": "",
    });

    if (data.isEntryFees === "yes") {
      this.setState({ isEntryFeesModaL: true });
    } else {
      var sendData = {
        contest_id: data.id,
        coupon: this.state.coupon,
        virtualFund: data.virtualFund,
      };
      axios
        .post(baseUrl + "api/participateCondition", sendData, config)
        .then((res) => {
          if (res.data.status) {
            this.setState({
              status: "active",
              show: false,
            });
            toast.success(res.data.message, toastStyles);
            window.location.reload();
          } else {
            toast.error(res.data.message, toastStyles);
            window.location.reload();
          }
          // setTimeout(function () {
          // window.location.reload();
          // }, 1000);
        })
        .catch();
    }
  };
  participate(id, virtualFund) {
    const { user } = this.props.auth;
    if (
      this.state.coupon === "" ||
      (this.state.coupon === undefined && this.state.couponRequired === "yes")
    ) {
      toast.error("Please enter entry code", toastStyles);
      return false;
    }
    // console.log("someData",this.state.isEntryFees)
    if (this.state.isEntryFees === "yes") {
      this.setState({ show: false, isEntryFeesModaL: true });
      return false;
    } else {
      this.setState({ participateBtnDisable: true });
      var sendData = {
        contest_id: id,
        coupon: this.state.coupon,
        virtualFund: virtualFund,
      };
      axios
        .post(baseUrl + "api/participateCondition", sendData, config)
        .then((res) => {
          this.setState({
            participateBtnDisable: false,
          });
          if (res.data.status) {
            this.setState({
              status: "active",
              show: false,
            });
            axios
              .post(baseUrl + "api/contestByID-data", { id: id }, config)
              .then((res) => {
                // console.log("res.data.data",res.data.data.item);
                if (res.data.data.item) {
                  const data = res.data.data.item;
                  var endDate = new Date(data.endDate);
                  endDate = endDate.toISOString();
                  var startDate = new Date(data.startDate);
                  startDate = startDate.toISOString();
                  window.webengage.track("Participation Completed", {
                    "Category Name": "Upcoming",
                    "Contest Name": data.contestName,
                    "Prize pool": data.winningAmount,
                    "Started At": new Date(startDate),
                    "Ends in": new Date(endDate),
                    "Number of participants": Number(data.numOfParticipation),
                    "Coupon code": res.data.data,
                  });
                }
              });
            toast.success(res.data.message, toastStyles);
          } else {
            toast.error(res.data.message, toastStyles);
          }
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        })
        .catch();
    }
  }

  handleRewardWalletCheck = (e) => {
    this.setState({ rewardWalletChecked: !this.state.rewardWalletChecked });
    this.calculateIt(
      this.state.cashWalletChecked,
      this.state.winningWalletChecked,
      !this.state.rewardWalletChecked
    );
  };

  handleCashWalletCheck = (e) => {
    this.setState({ cashWalletChecked: !this.state.cashWalletChecked });
    this.calculateIt(
      !this.state.cashWalletChecked,
      this.state.winningWalletChecked,
      this.state.rewardWalletChecked
    );
  };

  handleWinningWalletCheck = (e) => {
    this.setState({ winningWalletChecked: !this.state.winningWalletChecked });
    this.calculateIt(
      this.state.cashWalletChecked,
      !this.state.winningWalletChecked,
      this.state.rewardWalletChecked
    );
  };

  tabUpcomingViewDetailClick(contestId, tabType) {
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/contestByID-data", { id: contestId }, config)
      .then((res) => {
        // console.log("res.data.dat============================",res.data.data.item);
        if (res.data.data.item) {
          const data = res.data.data.item;
          var endDate = data.endDate;
          endDate = endDate.toISOString();
          var startDate = data.startDate;
          startDate = startDate.toISOString();
          window.webengage.track("Virtual Trading_Contest Details Viewed", {
            "Category Name": tabType,
            "Contest Name": data.contestName,
            "Current Status": "Upcoming",
            "Ends in": new Date(endDate),
            "Number of participants": data.numOfParticipation,
            "Prize pool": data.winningAmount,
            "Started At": new Date(startDate),
          });
        }
      });
  }
  calculateIt = (cashCheck, winningCheck, rewardCheck) => {
    var remainingAmount = this.state.entryFee;
    var rewardWalletDeduct = 0;
    var winningWalletDeduct = 0;
    var cashWalletDeduct = 0;

    if (rewardCheck) {
      var rewardWalletDeduct = (remainingAmount * 50) / 100;
      rewardWalletDeduct =
        rewardWalletDeduct > this.state.bonus
          ? this.state.bonus
          : rewardWalletDeduct;
      var remainingAmount = remainingAmount - rewardWalletDeduct;
    }

    if (winningCheck) {
      var winningWalletDeduct = remainingAmount;
      winningWalletDeduct =
        parseInt(winningWalletDeduct) >
        parseInt(this.state.winningWalletBalance)
          ? this.state.winningWalletBalance
          : winningWalletDeduct;

      var remainingAmount = remainingAmount - winningWalletDeduct;
    }

    if (cashCheck) {
      var cashWalletDeduct = remainingAmount;
      cashWalletDeduct =
        cashWalletDeduct > this.state.cashWalletBalance
          ? this.state.cashWalletBalance
          : cashWalletDeduct;
      var remainingAmount = remainingAmount - cashWalletDeduct;
    }

    this.setState({
      rewardWalletDeduct: rewardWalletDeduct,
      winningWalletDeduct: winningWalletDeduct,
      cashWalletDeduct: cashWalletDeduct,
    });
  };

  showTimerCounterHtml = (getStartDateTime, getIndex) => {
    var startContestDateTime = new Date(getStartDateTime);

    // var today = new Date();
    // var timeComplete = moment().format('HH')+':'+moment().format('mm')+":"+moment().format('ss');
    // var currentDate1 = ("0" + (today.getUTCDate())).slice(-2);
    // var dateformat = today.getUTCFullYear()+'-'+(today.getUTCMonth()+1)+'-'+currentDate1+" "+timeComplete;
    var dateformat = this.state.serverTime;
    var currentDate = new Date(dateformat);
    startContestDateTime = startContestDateTime;
    startContestDateTime = startContestDateTime / 1000;
    currentDate = Date.parse(currentDate);
    currentDate = currentDate / 1000;
    const countdown = moment(startContestDateTime - currentDate);
    var duration = moment.duration(countdown * 1000, "milliseconds");
    var interval = 1000;
    duration = moment.duration(duration - interval, "milliseconds");
    // console.log("getStartDateTime==",duration);
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const symbol1 = this.props.symbol;

    if (days > 0 || hours > 0 || minutes > 0 || seconds > 0) {
      this.state.days[getIndex] = days;
      this.state.hours[getIndex] = hours;
      this.state.minutes[getIndex] = minutes;
      this.state.seconds[getIndex] = seconds;
      this.setState({ aa: "done" });
      //location.reload();
    }
    if (days === 0 && minutes === 0 && hours === 0 && seconds === 0) {
      window.location.reload();
    }
  };

  showChatHtml = () => {
    var month_name = function (dt) {
      var mlist = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return mlist[dt.getMonth()];
    };
    let classThis = this;
    const html = [];
    if (this.state.records.length > 0) {
      console.log("this.state.recordsthis.state.records=", this.state.records);
      this.state.records.map(function (value, i) {
        // start date time
        //  let startDateTime1 = value.startDate+" "+value.startTime;
        let startDateTime1 = value.startDate;
        startDateTime1 = moment.utc(value.startDate).format("YYYY-MM-DD HH:mm");

        var startDateTime = new Date(startDateTime1);
        // end date time
        //  let expriryDateTime1 = value.endDate+" "+value.endTime;

        let expriryDateTime1 = new Date(value.endDate);
        expriryDateTime1 = moment.utc(value.endDate).format("YYYY-MM-DD HH:mm");
        // console.log("expriryDateTime1==",expriryDateTime1);
        var endDateTime = new Date(expriryDateTime1);
        var expriry = Date.parse(endDateTime);
        expriry = expriry / 1000;
        var currentDate = Date.parse(startDateTime);
        currentDate = currentDate / 1000;
        const countdown = moment(expriry - currentDate);
        var duration = moment.duration(countdown * 1000, "milliseconds");
        var interval = 1000;
        duration = moment.duration(duration - interval, "milliseconds");
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        // time diffrence
        var dateObj1 = new Date(value.startDate);
        var day1 = dateObj1.getUTCDate();
        var dateObj2 = new Date(value.endDate);
        var day2 = dateObj2.getUTCDate();

        setTimeout(function () {
          classThis.showTimerCounterHtml(startDateTime1, i);
        }, 1000);
        html.push(
          <>
            <div className="col-xl-4 col-lg-6 col-md-6  mt-3 mt-md-4">
              <div className="crypt-market-status2 past_man_box">
                <div className="past_man_box-inner">
                  <div className="row top_contest">
                    <div className="col-12 text-center">
                      {" "}
                      <h6>{value.contestName}</h6>
                    </div>
                  </div>

                  <div className="row mt-3">
                    {/*<div className="col-4 ">
                                       <span className="op_0_5"> Duration</span>
                                   </div>
                                   <div className="col-8 tr">
                                   <span className="timerdiv2 past_value">
                                       <span>{days}D</span>
                                       <span>:</span>
                                       <span>{hours}H</span>
                                       <span>:</span>
                                      <span>{minutes}M</span>
                                       <span>:</span>
                                     <span className="timercounter">{seconds}S </span>
                                     </span>
                                   </div> */}

                    <div className="col-4 ">
                      <span className="op_0_5"> Starts In</span>
                    </div>
                    <div className="col-8 tr">
                      <span className="timerdiv2 past_value">
                        <span>{classThis.state.days[i]}D</span>
                        <span>:</span>
                        <span>{classThis.state.hours[i]}H</span>
                        <span>:</span>
                        <span>{classThis.state.minutes[i]}M</span>
                        <span>:</span>
                        <span className="timercounter">
                          {classThis.state.seconds[i]}S{" "}
                        </span>
                      </span>
                    </div>

                    <div className="col-6 col-md-4">
                      <span>Ends on </span>
                    </div>
                    <div className="col-6 col-md-8 ">
                      <span className="past_value">
                        {moment.utc(value.endDate).format("YYYY-MM-DD HH:mm")}
                        {/* {month_name(new Date(value.endDate))}, {day2} ({value.endTime}) */}
                      </span>
                    </div>
                    {classThis.state.contestCreated === "Admin" && (
                      <>
                        {" "}
                        <div className="col-6 col-md-4">
                          <span>Exchange </span>
                        </div>
                        <div className="col-6 col-md-8 ">
                          <span className="past_value">
                            {value.exchange_type.toUpperCase()}
                          </span>
                        </div>
                      </>
                    )}
                    <div className="col-6 col-md-6 ">
                      <span className="op_0_5"> Prize pool</span>
                    </div>
                    <div className="col-6 col-md-6 ">
                      <span className="past_value">
                        {/* <i className="fa fa-inr"></i> */}
                        {value.winningAmount}{" "}
                        {value.winning_distribution_type == "byPoints"
                          ? "Points"
                          : ""}
                        {value.winning_distribution_type == "cash" ? "₹" : ""}
                        {value.winning_distribution_type == "pool" ? "₹" : ""}
                        {value.winning_distribution_type == "byCoins"
                          ? "Coins"
                          : ""}{" "}
                      </span>
                    </div>

                    {/* <div className="col-6 col-md-6">
                                       <span className="op_0_5"> Entry Fee</span>
                                      
                                   </div>
                                   <div className="col-6 col-md-6 ">
                                      
                                       <span className="past_value"><i className="fa fa-inr"></i> {value.entryFee}</span>
                                   </div> */}

                    <div className="col-6">
                      <span className="op_0_5"> Participants</span>
                    </div>

                    <div className="col-6">
                      <span className="past_value">
                        {value.numOfParticipation +
                          "/" +
                          (value.max_particepate != undefined
                            ? value.max_particepate
                            : "0")}
                      </span>
                    </div>
                    {/*<div className="col-6 col-md-4">
                                       <span >Starts on </span>
                                      
                                   </div> 
                                   <div className="col-6 col-md-8 ">
                                      <span className="past_value">{month_name(new Date(value.startDate))}, {day2} ({value.startTime})</span>
                                   </div>*/}
                  </div>
                  <div className="details-outer row">
                    <div className="col-6 col-md-6">
                      <Link
                        className="view_dital"
                        to={
                          "/trading-contest/" +
                          value.id +
                          classThis.state.urltemp
                        }
                        onClick={() =>
                          classThis.tabUpcomingViewDetailClick(
                            value.id,
                            "Upcoming"
                          )
                        }
                      >
                        <span>
                          <i className="las la-trophy"></i> View Details
                        </span>
                      </Link>
                    </div>
                    <div className="col-6 col-md-6 tr">
                      {value.couponRequired === "yes" ? (
                        value.currentStatus == "1" ? (
                          <h6> Already Participated </h6>
                        ) : value.numOfParticipation !=
                          value.max_particepate ? (
                          <button
                            type="button"
                            className="btn btn_man p_button"
                            onClick={() => classThis.participatedata(value)}
                            data-toggle="modal"
                            data-target="#participateModal"
                          >
                            Participate Now{" "}
                          </button>
                        ) : (
                          "Participation limit exceeded"
                        )
                      ) : value.currentStatus == "1" ? (
                        <h6> Already Participated </h6>
                      ) : value.numOfParticipation != value.max_particepate ? (
                        <button
                          type="button"
                          className="btn btn_man p_button"
                          onClick={() => classThis.participatedata22(value)}
                        >
                          Participate Now
                        </button>
                      ) : (
                        "Participation limit exceeded"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      });
    } else {
      return (
        <>
          <div className="container mt-4">
            <div className="crypt-market-status2 data_not_found pt-5 pb-5 text-center">
              <p className="mt-5 mb-5 text-center">
                No upcoming contest available
              </p>
            </div>
          </div>
        </>
      );
    }

    return html;
  };
  onChange = (e) => {
    // alert(e.target.value,"fsfd");
    if (e.target.id === "coupon") {
      this.setState({ coupon: e.target.value });
    }
  };

  onUserUpdate = (e) => {
    const { user } = this.props.auth;
    e.preventDefault();
    const newUser = {
      _id: this.props.match.params.id,
      user_id: user.id,
      description: this.state.description,
    };
    this.props.requery(newUser);
  };

  hideModal = () => {
    this.setState({ show: false, isEntryFeesModaL: false });
  };

  contestPayment = () => {
    // console.log("this.state.entryFeeTypeRequired===",this.state.entryFeeTypeRequired);
    let data;
    if (this.state.isEntryFees === "yes") {
      data = {
        coupon: this.state.coupon,
        contestId: this.state.id,
        pointsRequire: this.state.poitsRequire,
        entryFeeTypeRequired: this.state.entryFeeTypeRequired,
      };
    } else {
      data = {
        contestId: this.state.id,
        pointsRequire: this.state.poitsRequire,
        entryFeeTypeRequired: this.state.entryFeeTypeRequired,
      };
    }
    axios.post(baseUrl + "api/pay-contest-fee", data, config).then((res) => {
      var resp = res.data;
      if (resp.success === true) {
        this.setState({ isEntryFeesModaL: false });
        if (this.state.isEntryFees === "yes") {
          var sendData = {
            contest_id: this.state.id,
            coupon: this.state.coupon,
            virtualFund: this.state.virtualFund,
          };
          axios
            .post(baseUrl + "api/participateCondition", sendData, config)
            .then((res) => {
              if (res.data.status) {
                this.setState({
                  status: "active",
                  show: false,
                });
                toast.success(res.data.message, toastStyles);
                window.location.reload();
              } else {
                toast.error(res.data.message, toastStyles);
                window.location.reload();
              }
            })
            .catch();
        } else {
          var sendData = {
            contest_id: this.state.id,
            virtualFund: this.state.virtualFund,
          };
          axios
            .post(baseUrl + "api/participateCondition", sendData, config)
            .then((res) => {
              if (res.data.status) {
                this.setState({
                  status: "active",
                  show: false,
                });
                toast.success(res.data.message, toastStyles);
                window.location.reload();
              } else {
                toast.error(res.data.message, toastStyles);
                window.location.reload();
              }
              // setTimeout(function () {
              // window.location.reload();
              // }, 1000);
            });
        }
      } else {
        this.setState({ isEntryFeesModaL: true });
        toast.error(resp.message);
      }
    });
  };

  render() {
    var settings = {
      initialSlide: 0,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const { errors } = this.state;
    const { user } = this.props.auth;
    return (
      <>
        <div className="row">{this.showChatHtml()}</div>

        <Modal
          show={this.state.show}
          onHide={this.hideModal}
          dialogClassName="modal-90w mx400"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <h5 className="modal-title" id="exampleModalLabel">
                Please enter entry code
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              {this.state.couponRequired === "no" && <label>Entry Code</label>}
              {this.state.couponRequired === "yes" && (
                <label>
                  Entry Code<span className="text-danger"> *</span>
                </label>
              )}
              <input
                onChange={this.onChange}
                className="form-control"
                value={this.state.coupon}
                id="coupon"
                type="text"
                placeholder="Coupon"
                required
              />
              {this.state.couponRequired === "no" && (
                <label className="form-check-label" for="flexCheckChecked">
                  <br />
                  <span className="text-danger">
                    Note: Please click on skip Button
                  </span>
                </label>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.hideModal}>
              Close
            </Button>
            <button
              variant="primary"
              className="btn btn_man"
              disabled={this.state.participateBtnDisable}
              onClick={() =>
                this.participate(this.state.id, this.state.virtualFund)
              }
            >
              {this.state.couponRequired === "yes" && "Participate"}
              {this.state.couponRequired === "no" && "Skip"}
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.isEntryFeesModaL}
          onHide={this.hideModal}
          dialogClassName="modal-90w mx400"
          aria-labelledby="example-custom-modal-styling-title"
          className="fade modal entry-funds"
        >
          <Modal.Header className="justify-content-between align-items-center">
            <Modal.Title id="example-custom-modal-styling-title">
              <h6 className="modal-title" id="exampleModalLabel">
                Add djgasj {this.state.entryFeeTypeRequired}d
                {this.state.entryFeeTypeRequired == "points" &&
                  "Points To Enter The Contest"}
                {this.state.entryFeeTypeRequired == "cash" &&
                  "Funds To Enter The Contest"}
              </h6>
            </Modal.Title>
            {this.state.entryFeeTypeRequired == "cash" &&
              this.state.cashWalletBalance < this.state.poitsRequire && (
                <Link
                  className="btn btn_man"
                  to={
                    this.state.urltemp !== ""
                      ? "/addCash" + this.state.urltemp
                      : "/addCash"
                  }
                >
                  Add Funds
                </Link>
              )}
          </Modal.Header>
          <Modal.Body>
            {/* <div className="form-check">                     */}
            <div className="form-group">
              {this.state.poitsRequire > 0 && (
                <label className="m-0">
                  {this.state.entryFeeTypeRequired == "cash"
                    ? "Funds"
                    : "Points"}{" "}
                  Required to Participate:{" "}
                  {this.state.entryFeeTypeRequired == "cash" ? "₹" : ""}{" "}
                  {this.state.poitsRequire}
                  <span className="text-danger"> *</span>
                </label>
              )}
            </div>
            <div className="form-group">
              {this.state.entryFeeTypeRequired == "cash" ? (
                <lable className="m-0">
                  Avaliable Funds: ₹{" "}
                  {(
                    this.state.cashWalletBalance +
                    parseFloat(this.state.winningCash)
                  ).toFixed(2)}{" "}
                </lable>
              ) : (
                <lable>
                  Avaliable Points: {this.state.userAvaliablePoints}
                </lable>
              )}
            </div>
            {this.state.entryFeeTypeRequired == "points" &&
              this.state.userAvaliablePoints < this.state.poitsRequire && (
                <div className="form-group">
                  <span className="text-danger">
                    Not enough points to participate:{" "}
                    {parseFloat(this.state.poitsRequire) -
                      parseFloat(this.state.userAvaliablePoints)}
                  </span>
                </div>
              )}
            {this.state.entryFeeTypeRequired == "cash" &&
              this.state.cashWalletBalance < this.state.poitsRequire && (
                <div className="form-group">
                  {/* <lable className='m-0'>Avaliable Winning Fund: ₹ {parseFloat(this.state.winningCash) }</lable><br/> */}
                  {this.state.cashWalletBalance + this.state.winningCash <
                    this.state.poitsRequire && (
                    <span className="text-danger">
                      Not enough funds to participate: ₹{" "}
                      {(
                        parseFloat(this.state.poitsRequire) -
                        (parseFloat(this.state.cashWalletBalance) +
                          parseFloat(this.state.winningCash))
                      ).toFixed(2)}
                    </span>
                  )}
                </div>
              )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.hideModal}>
              Close
            </Button>
            {this.state.entryFeeTypeRequired == "points" &&
              this.state.userAvaliablePoints >= this.state.poitsRequire && (
                <button
                  variant="primary"
                  className="btn btn_man"
                  disabled={this.state.participateBtnDisable}
                  onClick={() =>
                    this.contestPayment(this.state.id, this.state.virtualFund)
                  }
                >
                  {this.state.poitsRequire > 0 && "Pay"}
                </button>
              )}
            {this.state.entryFeeTypeRequired == "cash" &&
              this.state.cashWalletBalance + this.state.winningCash >=
                this.state.poitsRequire && (
                <button
                  variant="primary"
                  className="btn btn_man"
                  disabled={this.state.participateBtnDisable}
                  onClick={() =>
                    this.contestPayment(this.state.id, this.state.virtualFund)
                  }
                >
                  {this.state.poitsRequire > 0 && "Pay"}{" "}
                </button>
              )}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

UpcomingContest.propTypes = {
  requery: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { requery })(
  withRouter(UpcomingContest)
);
